import { observable, action } from "mobx";
import User from "~/models/User";
import UserMeRepository from "~/repository/UserMeRepository";
import NestStore from "./NestStore";

class UserStore {
  /**
   * @property boolean
   */
  @observable loading = false;

  /**
   * @property boolean
   */
  @observable isLoaded = false;

  /**
   * @property User
   */
  @observable user = null;

  /**
   * @property {string}
   */
  @observable errorMessage = "";

  /**
   * @property {Object}
   */
  @observable errorMessages = {};

  /**
   * @private
   */
  #userCopy;

  nestStore = null;

  userMeRepository = null;

  constructor() {
    this.nestStore = new NestStore();
    this.user = new User({});
    this.userMeRepository = new UserMeRepository();
  }

  @action
  load(reload = false) {
    // since the logged user info will rarely change, we'll return the cached user in case it has been already
    // fetched.

    // The user is set to an empty user, let's check for the user id to tell if it has been loaded already.
    if (this.user.userId && !reload) {
      // No need to return any special value, the user data will be readily available via store.user
      return Promise.resolve();
    }

    this.loading = true;

    return this.userMeRepository
      .fetch()
      .then(response => {
        const { user } = response.data;

        this.user = new User(user);
        this.isLoaded = true;

        return this.user;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @action
  save = data => this.saveUser(data);

  /**
   * @private
   */
  saveUser(data) {
    this.isSaving = true;
    this.errorMessages = {};
    this.errorMessage = "";
    return this.userMeRepository
      .update(data)
      .then(response => {
        if (response.status === "success" && response.data.user) {
          this.user = new User(response.data.user);
          this.#userCopy = response.data.user;
        }
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  @action
  setErrorMessages(error) {
    if (error.status === "fail") {
      this.errorMessages = error.message;
    } else {
      this.errorMessage = error.message;
    }
  }
}

export default UserStore;
